<template>
	<div class="container">
		<!-- 左侧品牌区域 -->
		<div class="brand-section">
			<div class="logo">
				<i class="el-icon-s-goods"></i>
				户外旅行投保
			</div>
			<div class="brand-content">
				<h1 class="brand-title">安全户外之旅</h1>
				<p class="brand-subtitle">专业户外保险，为您的冒险保驾护航</p>

				<div class="features">
					<div class="feature-item">
						<div class="feature-icon">
							<i class="el-icon-s-flag"></i>
						</div>
						<span>全方位保障</span>
					</div>
					<div class="feature-item">
						<div class="feature-icon">
							<i class="el-icon-s-opportunity"></i>
						</div>
						<span>快速理赔</span>
					</div>
					<div class="feature-item">
						<div class="feature-icon">
							<i class="el-icon-s-custom"></i>
						</div>
						<span>全球救援</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 右侧登录区域 -->
		<div class="login-section">
			<i @click="close" class="el-icon-close close-btn"></i>

			<div class="login-header">
				<h2 class="login-title">{{ type === 'login' ? '欢迎回来' : '创建账户' }}</h2>
				<p class="login-subtitle">{{ type === 'login' ? '请登录您的账户' : '请填写注册信息' }}</p>
			</div>

			<!-- 标签页切换 -->
			<div class="tab-container">
				<div class="tabs">
					<div class="tab" :class="{ active: type === 'login' }" @click="switchTab('login')">
						密码登录
					</div>
					<div class="tab" :class="{ active: type === 'register' }" @click="switchTab('register')">
						手机注册
					</div>
				</div>

				<!-- 密码登录 -->
				<login-form v-if="type === 'login'" :loading="loading" @login="handleLogin"
					@show-forgot-password="showForgotPassword = true" />

				<!-- 手机注册 -->
				<register-form v-else :loading="loading" @register="handleRegister" @send-code="sendVerificationCode" />
			</div>

			<!-- 第三方登录 -->
			<div class="social-login-wrapper">
				<!-- 根据浏览器环境自动切换微信登录组件 -->
				<template v-if="isWeChatBrowser">
					<!-- 微信浏览器内使用原有组件 -->
					<wechat-login @wechat-login-success="handleWechatLoginSuccess"
						@need-bind-phone="handleNeedBindPhone" />
				</template>
				<!-- <template v-else>
					<wechat-qr-login @wechat-login-success="handleWechatLoginSuccess"
						@need-bind-phone="handleNeedBindPhone" @wechat-login="handleWechatBrowserLogin" />
				</template> -->
			</div>

			<!-- 用户协议 -->
			<div class="agreement">
				注册即表示您同意我们的
				<a href="/#/doc?id=1" target="_blank" rel="noopener">用户协议</a>
				和
				<a href="/#/doc?id=2" target="_blank" rel="noopener">隐私政策</a>
			</div>

			<!-- 忘记密码弹窗 -->
			<forgot-password :visible="showForgotPassword" :loading="forgotPasswordLoading"
				@close="showForgotPassword = false" @submit="resetPassword" @send-code="sendVerificationCode" />
		</div>
	</div>
</template>

<script>
	import LoginForm from './loginComponents/loginForm.vue'
	import RegisterForm from './loginComponents/registerForm.vue'
	import ForgotPassword from './loginComponents/forgotPassword.vue'
	import WechatLogin from './loginComponents/wechatLogin.vue'
	import WechatQrLogin from './loginComponents/wechatQrLogin.vue'

	export default {
		name: 'LoginRegister',
		components: {
			LoginForm,
			RegisterForm,
			ForgotPassword,
			WechatLogin,
			WechatQrLogin
		},
		data() {
			return {
				type: 'login',
				loading: false,
				showForgotPassword: false,
				forgotPasswordLoading: false
			}
		},
		computed: {
			isWeChatBrowser() {
				const ua = navigator.userAgent.toLowerCase()
				return ua.indexOf('micromessenger') > -1
			}
		},
		methods: {
			close() {
				this.$emit('close')
			},

			switchTab(tabType) {
				this.type = tabType
			},

			async handleLogin(loginForm) {
				this.loading = true
				try {
					this.$post('passwordLogin', loginForm).then(res => {
						this.$message.success('登录成功')
						this.$emit('close', loginForm)
						if (res.extra.UserCheck) {
							this.$apimit.set(res.extra.UserCheck)
							this.$vuex('UserInfo', res.data, true)
							this.$vuex('UserCheck', res.extra.UserCheck, true)
						} else {
							this.loading = false
							this.$notify.error({
								message: '请重新登陆'
							})
						}
					}).catch(err => {
						this.$message.error(err)
						this.loading = false
					})
				} catch (error) {
					this.$message.error('登录失败，请检查手机号和密码')
					this.loading = false
				}
			},

			async handleRegister(registerForm) {
				this.loading = true
				try {
					this.$post('phoneRegister', registerForm).then(res => {
						this.$message.success('注册成功')
						this.$emit('close', registerForm)
						if (res.extra.UserCheck) {
							this.$apimit.set(res.extra.UserCheck)
							this.$vuex('UserInfo', res.data, true)
							this.$vuex('UserCheck', res.extra.UserCheck, true)
						} else {
							this.loading = false
							this.$notify.error({
								message: '登录失败'
							})
						}
					}).catch(err => {
						this.$message.error(err)
						this.loading = false
					})
				} catch (error) {
					this.$message.error('注册失败，请稍后重试')
					this.loading = false
				}
			},

			sendVerificationCode(phone) {
				this.$post('sendAliyunSms', {
					phone: phone,
				}).then(res => {
					this.$message.success('验证码已发送')
				}).catch(err => {
					this.$message.error(err)
				});
			},

			async resetPassword(formData) {
				this.forgotPasswordLoading = true
				try {
					this.$post('forgetPassword', formData).then(res => {
						this.$message.success('密码重置成功')
						this.showForgotPassword = false
						this.forgotPasswordLoading = false
						// 自动切换到登录标签页
						this.type = 'login'
					}).catch(err => {
						this.$message.error(err)
						this.forgotPasswordLoading = false
					})
				} catch (error) {
					this.$message.error('密码重置失败，请稍后重试')
					this.forgotPasswordLoading = false
				}
			},

			// 微信扫码登录成功
			handleWechatLoginSuccess(userData) {
				try {
					this.$message.success('微信登录成功')

					// 关闭登录弹窗
					this.$emit('close', userData)

					// 触发事件通知navbar更新
					this.$emit('wechat-login-success', userData)

				} catch (error) {
					console.error('微信登录成功处理失败:', error)
				}
			},

			// 微信浏览器登录
			handleWechatBrowserLogin() {
				// 微信浏览器内登录由wechatLogin组件处理
				// 这里可以添加一些额外的处理逻辑
			},

			// 需要绑定手机号
			handleNeedBindPhone(wechatInfo) {
				// 存储微信信息到缓存，navbar.vue会监听并弹出绑定弹窗
				this.$vuex('wechat_info', wechatInfo, true)

				// 关闭登录弹窗
				this.close()

				// 提示用户
				this.$message.info('请完成手机号绑定')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		display: flex;
		width: 100%;
		max-width: 900px;
		min-height: 500px;
		background: white;
		border-radius: 16px;
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		max-height: 90vh;

		@media (max-width: 1280px) {
			max-width: 850px;
			min-height: 480px;
		}

		@media (max-width: 1024px) {
			max-width: 800px;
			min-height: 450px;
			max-height: 85vh;
		}

		@media (max-width: 900px) {
			max-width: 750px;
			min-height: 420px;
			max-height: 82vh;
		}

		@media (max-width: 768px) {
			flex-direction: column;
			max-width: 95%;
			min-height: auto;
			position: relative;
			left: auto;
			top: auto;
			transform: none;
			margin: 20px auto;
			max-height: 90vh;
			overflow-y: auto;
		}

		@media (max-width: 480px) {
			max-width: 100%;
			margin: 10px;
			border-radius: 12px;
			max-height: 95vh;
		}

		@media (max-width: 360px) {
			margin: 5px;
			border-radius: 8px;
			max-height: 98vh;
		}
	}

	.brand-section {
		flex: 0.8;
		background: linear-gradient(135deg, #2280FD 0%, #1a6fd0 100%);
		color: white;
		padding: 40px 30px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		overflow: hidden;

		@media (max-width: 1280px) {
			padding: 35px 25px;
		}

		@media (max-width: 1024px) {
			flex: 0.7;
			padding: 30px 25px;
		}

		@media (max-width: 900px) {
			padding: 25px 20px;
			flex: 0.65;
		}

		@media (max-width: 768px) {
			flex: none;
			padding: 25px 20px;
			min-height: 180px;
		}

		@media (max-width: 480px) {
			padding: 20px 15px;
			min-height: 150px;
		}

		@media (max-width: 360px) {
			padding: 15px 12px;
			min-height: 130px;
		}
	}

	.brand-section::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="rgba(255,255,255,0.05)"><polygon points="0,0 100,0 100,100"/></svg>');
	}

	.logo {
		display: flex;
		align-items: center;
		font-size: 22px;
		font-weight: 700;
		margin-bottom: 25px;
		position: relative;
		z-index: 1;
	}

	.brand-content {
		position: relative;
		z-index: 1;
	}

	.brand-title {
		font-size: 24px;
		font-weight: 700;
		margin-bottom: 15px;
		line-height: 1.3;
	}

	.brand-subtitle {
		font-size: 14px;
		opacity: 0.9;
		margin-bottom: 20px;
		line-height: 1.5;
	}

	.features {
		display: flex;
		flex-direction: column;
		gap: 15px;
		margin-top: 25px;
	}

	.feature-item {
		display: flex;
		align-items: center;
		gap: 12px;
		font-size: 14px;
	}

	.feature-icon {
		width: 20px;
		height: 20px;
		background: rgba(255, 255, 255, 0.2);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		flex-shrink: 0;
	}

	.login-section {
		flex: 1;
		padding: 20px 35px 40px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		position: relative;
		overflow-y: auto;
		max-height: 100%;

		@media (max-width: 1280px) {
			padding: 18px 30px 35px;
		}

		@media (max-width: 1024px) {
			padding: 20px 30px 35px;
		}

		@media (max-width: 900px) {
			padding: 15px 25px 30px;
		}

		@media (max-width: 768px) {
			padding: 20px 25px 30px;
		}

		@media (max-width: 480px) {
			padding: 15px 20px 25px;
		}

		@media (max-width: 360px) {
			padding: 12px 15px 20px;
		}
	}

	.close-btn {
		position: absolute;
		top: 15px;
		right: 15px;
		font-size: 22px;
		cursor: pointer;
		color: #999;
		transition: color 0.3s ease;

		&:hover {
			color: #333;
		}
	}

	.login-header {
		text-align: center;
		margin-bottom: 25px;
	}

	.login-title {
		font-size: 22px;
		font-weight: 600;
		color: #333;
		margin-bottom: 8px;
	}

	.login-subtitle {
		color: #666;
		font-size: 14px;
	}

	.tab-container {
		margin-bottom: 20px;
	}

	.tabs {
		display: flex;
		background: #f5f5f5;
		border-radius: 10px;
		padding: 3px;
		margin-bottom: 20px;
	}

	.tab {
		flex: 1;
		padding: 10px;
		text-align: center;
		border-radius: 8px;
		cursor: pointer;
		font-weight: 500;
		font-size: 14px;
		transition: all 0.3s ease;
		color: #666;
	}

	.tab.active {
		background: white;
		color: #2280FD;
		box-shadow: 0 2px 6px rgba(34, 128, 253, 0.15);
	}

	.social-login-wrapper {
		margin-top: 25px;
	}

	.agreement {
		text-align: center;
		margin-top: 20px;
		font-size: 12px;
		color: #999;
	}

	.agreement a {
		color: #2280FD;
		text-decoration: none;
	}

	.agreement a:hover {
		text-decoration: underline;
	}

	/* 响应式样式 */
	@media (max-width: 768px) {
		.login-title {
			font-size: 20px;
		}

		.login-subtitle {
			font-size: 13px;
		}

		.tab {
			padding: 8px;
			font-size: 13px;
		}

		.agreement {
			font-size: 11px;
			margin-top: 15px;
		}

		.social-login-wrapper {
			margin-top: 20px;
		}
	}
</style>